import { render, staticRenderFns } from "./LessonSummary.vue?vue&type=template&id=3a5d766e&scoped=true"
import script from "./LessonSummary.vue?vue&type=script&lang=js"
export * from "./LessonSummary.vue?vue&type=script&lang=js"
import style0 from "./LessonSummary.vue?vue&type=style&index=0&id=3a5d766e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5d766e",
  null
  
)

export default component.exports